import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithLogoutGuard } from "../../../common/createBaseQueryWithLogoutGuard";

export const secondaryConsumersTrendSlice = createApi({
  reducerPath: "secondaryConsumersTrend",
  baseQuery: createBaseQueryWithLogoutGuard({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["SecondaryConsumersTrend"],
  endpoints: (build) => ({
    getSecondaryConsumersTrend: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/primary_consumer/trend`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
      providesTags: (_) => ["secondaryConsumersTrend"],
    }),
  }),
});

export const { useGetSecondaryConsumersTrendQuery } =
  secondaryConsumersTrendSlice;

export const useQueryStateSecondaryConsumersTrend = (queryHook, args) => {
  const result = queryHook(args);
  return {
    data: result?.data?.data[0],
    isLoading: result?.isLoading,
    isFetching: result?.isFetching,
    isError: result?.isError,
    error: result?.error,
  };
};
